import {$, ID, Resource} from 'simpli-web-sdk'
import SacResponseSchema from '@/schema/SacResponse.schema'
import {SacType} from '@/enums/SacType'
import moment from 'moment'
import { SacEvent } from '@/enums/SacEvent'

export default class SacResponse extends Resource {
  readonly $name: string = 'SacResponse'
  readonly $endpoint: string = '/user/carga/tentativa'

  get $schema() {
    return SacResponseSchema(this)
  }

  get $id() {
    return this.idCarga
  }

  set $id(val: ID) {
    this.idCarga = val
  }

  idCarga: ID = 0
  attempt: number | null = null
  type: number | null = null
  status: string | null  = null
  event: string | null  = null
  date: string | null  = null
  shipperName: string | null  = null

  get statusTagClass() {
    if (this.type === SacType.OCCURRENCE) {
      return 'orange'
    }
    if (this.type === SacType.RETURNED) {
      return 'danger'
    }
    return 'default'
  }

  get trackingIcon() {
    if (this.type === SacType.PENDING && this.event === SacEvent.SHIPPING) {
      return './img/itrack/tracking/aguardando-rota.png'
    } else if (this.type === SacType.PENDING && this.event === SacEvent.SCHEDULED) {
      return './img/itrack/tracking/em-processo-entrega.png'
    } else if (this.type === SacType.STARTED) {
      return './img/itrack/tracking/proxima-entrega.png'
    } else if (this.type === SacType.CHECKIN) {
      return './img/itrack/tracking/checkin.png'
    } else if (this.isOcorrencia) {
      return './img/itrack/tracking/ocorrencia.png'
    } else if (this.type === SacType.ENDED) {
      return './img/itrack/tracking/entregue-com-sucesso.png'
    } else if (this.event === SacEvent.CREATED) {
      return './img/itrack/tracking/emissao-nota-fiscal.jpg'
    }
  }

  get isOcorrencia() {
    return (this.type === SacType.OCCURRENCE || this.type === SacType.RETURNED)
  }

  get formattedDate() {
    if (this.date === null) {
      return null
    }
    return moment(this.date).format($.t('dateFormat.datetime'))
  }

  get formattedEvent() {
    if (this.event === null) {
      return null
    }
    return this.event.charAt(0).toUpperCase() + this.event.toLowerCase().slice(1)
  }
}
